import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { NdcTechnicalFaqPage } from 'src/app/model/page/group/faq/ndc-technical-faq-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-ndc-technical-faq-page',
  templateUrl: './ndc-technical-faq-page.component.html',
  styleUrls: ['./ndc-technical-faq-page.component.scss']
})
export class NdcTechnicalFaqPageComponent implements OnInit {
  ndcTechnicalFaqPage: NdcTechnicalFaqPage = {} as NdcTechnicalFaqPage;
  BackLinkTitle: string = '';
  BackLinkURL: string = '';
  BackLinkIcon: string = '';

  constructor(private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'faq-technical') {
        this.ndcTechnicalFaqPage.htmlTitle = title.htmlTitle;
      }
    });
    this.ndcTechnicalFaqPage.sections = [];
    const query = { 'fields.title': 'NDC Technical FAQ' };
    this.contentfulService.getPageContentWithEntries(query).then((ndcTechnicalFaqPageEntries) => {
      this.mapBanner(ndcTechnicalFaqPageEntries);
      this.mapSections(ndcTechnicalFaqPageEntries);
    });
    this.contentfulService.getPageContentWithItems(query).then((linkItems) => {
      this.BackLinkTitle = linkItems[0]?.fields.constants[0].BackLinkTitle;
      this.BackLinkURL = linkItems[0]?.fields.constants[0].BackLinkURL;
      this.BackLinkIcon = linkItems[0]?.fields.constants[0].BackLinkIcon;
      this.ndcTechnicalFaqPage.htmlTitle = linkItems[0].fields.htmlTitle;
    });
  }
  private mapBanner(ndcTechnicalFaqPageEntries: Entry<any>[]) {
    ndcTechnicalFaqPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    this.ndcTechnicalFaqPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url
    };
  }
  private mapSections(ndcTechnicalFaqPageEntries: Entry<any>[]) {
    ndcTechnicalFaqPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.ndcTechnicalFaqPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#')[2];

    this.ndcTechnicalFaqPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }
}
